import difference from 'lodash/difference';

import type { NavItemConfigInternal, UserMenuData } from '../../types';

type Params = {
	forYouMenuId: string;
	globalItems: Map<string, NavItemConfigInternal>;
	rawUserMenuData: UserMenuData | null | undefined;
};

export function repairGlobalMenuItems(params: Params) {
	const { forYouMenuId, globalItems, rawUserMenuData } = params;

	// Sort the globalMenuIds so that the forYouItem is at the start, if it exists.
	const globalMenuIds = Array.from(globalItems.keys()).sort(
		(a, b) => Number(b === forYouMenuId) - Number(a === forYouMenuId),
	);

	const rawUserMenuDataArrMaybeWithForYou = rawUserMenuData ?? [];

	// If the userdata contains the forYou item, remove it so that it can be re-added into first position.
	const rawUserMenuDataArr = forYouMenuId
		? rawUserMenuDataArrMaybeWithForYou.filter((i) => i.menuId !== forYouMenuId)
		: rawUserMenuDataArrMaybeWithForYou;

	// Add the globalMenuIds to the user data, if they're not already there.
	const globalItemsNotInUserData = difference(
		globalMenuIds,
		rawUserMenuDataArr.map((i) => i.menuId),
	);

	return createDefaultItems(globalItemsNotInUserData).concat(rawUserMenuDataArr);
}

const createDefaultItems = (menuIds: string[]): UserMenuData =>
	menuIds.map((menuId) => ({ menuId, visible: true }));
